/* eslint-disable import-length/import-length */
import 'moment-timezone';
import 'moment/locale/es';

import InputEmailWithDomains from '@portalterreno/nextjs-client/components/InputEmailWithDomains';
import InputName from '@portalterreno/nextjs-client/components/InputName';
import InputPhone from '@portalterreno/nextjs-client/components/InputPhone';
import Visible from '@portalterreno/react-ui/Visible';
import React from 'react';

import Card from '../../../ContactForm/Card';
import StyledSubmitButton from '../../../ContactForm/StyledSubmitButton';
import WhatsappContact, {
  WhatsappContactProps
} from '../../../ContactForm/WhatsappContact';
import TermsAndConditions from '../../../TermsAndConditions';
import ReCaptchaTAC from '../../../TermsAndConditions/ReCaptchaTAC';
import TACDiv from '../../../TermsAndConditions/TACDiv';

export type FormValuesProps = React.HTMLAttributes<HTMLDivElement> &
  Pick<WhatsappContactProps, 'propertyId'> & {
    sellerWhatsapp?: WhatsappContactProps['sellerWhatsapp'];
    onClickWhatsappButton?: WhatsappContactProps['onClickWhatsappButton'];
  };

const FormValues: React.FC<FormValuesProps> = ({
  sellerWhatsapp,
  propertyId,
  onClickWhatsappButton,
  ...rest
}) => {
  return (
    <Card.Content {...rest}>
      <InputName />
      <InputEmailWithDomains />
      <InputPhone />
      <Visible desktop>
        <StyledSubmitButton />
        {onClickWhatsappButton && sellerWhatsapp && (
          <WhatsappContact
            onClickWhatsappButton={onClickWhatsappButton}
            sellerWhatsapp={sellerWhatsapp}
            propertyId={propertyId}
          />
        )}
      </Visible>
      <TACDiv>
        <TermsAndConditions />
        <ReCaptchaTAC />
      </TACDiv>
    </Card.Content>
  );
};

export default FormValues;
